import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import "./MainInfoSection.css";
import { useTranslation } from "react-i18next";

export default function MainInfoSection() {
  const { t } = useTranslation("translation", { keyPrefix: "main" });

  return (
    <section className="main__main-info-wrapper">
      <div className="main__main-info">
        <div className="main__main-info__copy">
          <div className="main__main-info__eyebrow">
            <span className="main__main-info__eyebrow-line" />
            <span>{t("organizationLabel")}</span>
          </div>

          <h1 className="main__main-info__primary-title">
            <span>ACTIVE</span>
            <span className="main__main-info__primary-title-accent">GENERATION</span>
          </h1>

          <p className="main__main-info__secondary-title">
            {t("activeGAboutInfo")}
          </p>

          <a className="main__main-info__button-link" href="#main__secondary-info">
            <button className="main__main-info__button">
              {t("readMoreBtn")}
              <KeyboardArrowRightRoundedIcon sx={{ fontSize: 24 }} />
            </button>
          </a>
        </div>

      </div>
    </section>
  );
}
